import type { FaireProductEntity } from "../../entity_types/product";

export const p_vrvm57q8su: FaireProductEntity = {
  token: "p_vrvm57q8su",
  type: "product",
  name: "Crystal Healing Stones .",
  brandToken: "b_6l28vptlbv",
  brandName: "Puka Creations",
  imageUrl:
    "https://cdn.faire.com/fastly/4f2576756811de9c6098e7943606bb0abdb918ec89e203f03b3e365e3a89e2b0.webp",
  galleryImageUrls: [],
  priceDollars: 4.16,
  description:
    "🔮✨ Add natural wellness appeal to your assortment with these Crystal Healing Stones. Featuring polished stones known for their spiritual and energy-balancing symbolism, these crystals are popular for meditation, mindfulness, and holistic lifestyle practices. Each stone showcases natural beauty and unique color variations, making them perfect for decorative displays, personal wellness rituals, or meaningful gifts. Compact and easy to carry, they can be used in meditation spaces, yoga studios, or everyday mindfulness routines. Ideal for gift shops, boutique retailers, and wellness stores seeking spiritually inspired items with strong impulse-buy appeal.\n\n🔎 crystal healing stones, healing crystal stones, natural crystal stones, spiritual healing crystals, meditation crystal stones, energy healing stones, polished crystal stones, wellness crystal stones, metaphysical crystal stones, chakra healing stones, gift shop crystal stones, spiritual gift crystals, natural gemstone stones, holistic healing crystals\n",
  tags: [],
  msrpDollars: 10.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:39.134Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
